import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NewAttendanceResponseModel } from 'data/attendance/attendance.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: NewAttendanceResponseModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<NewAttendanceResponseModel[]>> = (
  _,
  action,
) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default attendanceSlice;
